const BACKEND_URL = process.env.REACT_APP_BACKEND_URL as string;
export const API = `${BACKEND_URL}/api`;
